import React from 'react';
import { useDropdown } from './hooks';
export var Dropdown = React.forwardRef(function DropdownBase(_a, ref) {
    var renderContent = _a.renderContent, renderControl = _a.renderControl, renderPopover = _a.renderPopover, popoverConfig = _a.popoverConfig, _b = _a.autoClosable, autoClosable = _b === void 0 ? true : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, getAdditionalContentNode = _a.getAdditionalContentNode, onDidHide = _a.onDidHide, onDidShow = _a.onDidShow, onOutsideClick = _a.onOutsideClick;
    return useDropdown({
        ref: ref,
        autoClosable: autoClosable,
        renderControl: renderControl,
        renderContent: renderContent,
        renderPopover: renderPopover,
        offset: offset,
        popoverConfig: popoverConfig,
        getAdditionalContentNode: getAdditionalContentNode,
        onDidHide: onDidHide,
        onDidShow: onDidShow,
        onOutsideClick: onOutsideClick
    })[0];
});
Dropdown.defaultProps = {
    autoClosable: true,
    stopPropagation: true,
    offset: 0
};
Dropdown.displayName = 'Dropdown';
//# sourceMappingURL=Dropdown.js.map